module.exports = __webpack_public_path__ + "img/Nyromantikk_Andre_kunstformer_Debussy.b35d441d.jpg";